export default __webpack_public_path__ + "static/media/volinteer.480fbd84.svg";